export default {"src":"/_next/static/media/Refdocs_Logo_Colour_SVG.e226cafc.svg","height":203,"width":1000,"blurWidth":0,"blurHeight":0};